import { Lock, Users, Layers, Target } from "lucide-react";
import { Reveal } from "../site/Reveal";
import { SectionHeading } from "../site/SectionHeading";
import { PrimaryButton } from "../site/Buttons";
import { BOARDROOM_IMG } from "../../lib/site";

const STATS = [
  { Icon: Lock, top: "Invite Only", bottom: "Private Network" },
  { Icon: Users, top: "Members", bottom: "Growing Community" },
  { Icon: Layers, top: "Multiple Industries", bottom: "One Ecosystem" },
  { Icon: Target, top: "One Vision", bottom: "Build Together" },
];

export const AboutSection = () => (
  <section data-testid="about-section" className="bg-white py-28 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center">
      <div>
        <SectionHeading chapter="01" label="About MST" title={<>A Network Built on Trust, Governance &amp; Purpose</>} />
        <Reveal delay={0.15}>
          <div className="mt-8 space-y-6 text-[#6B7280] leading-[1.85]">
            <p>MST is more than a network — it is a structured private ecosystem designed to help members build together.</p>
            <p>
              We provide a safe and private environment where members can do business, invest,
              collaborate, and grow under established rules, bylaws, governance, accountability,
              and leadership.
            </p>
            <p>
              Our mission is to empower members to build, scale, and sustain multiple streams of
              income while creating lasting impact and generational wealth.
            </p>
          </div>
          <div className="mt-9">
            <PrimaryButton to="/about" data-testid="about-mission-btn">Our Mission</PrimaryButton>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2} className="relative">
        <div className="relative rounded-2xl overflow-hidden shadow-[0_25px_60px_rgba(4,21,37,0.35)]">
          <img src={BOARDROOM_IMG} alt="MST executive boardroom" loading="lazy" className="w-full h-[380px] sm:h-[440px] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#041525]/50 to-transparent" />
        </div>
        <div
          data-testid="about-stats-panel"
          className="relative -mt-14 mx-4 sm:mx-8 rounded-2xl bg-gradient-to-r from-[#006FD6] to-[#009BFF] shadow-[0_25px_60px_rgba(0,111,214,0.55),0_8px_25px_rgba(0,155,255,0.35)] grid grid-cols-2 sm:grid-cols-4 gap-y-6 px-6 py-6"
        >
          {STATS.map(({ Icon, top, bottom }) => (
            <div key={top} className="flex flex-col items-center text-center gap-1.5">
              <Icon size={20} strokeWidth={1.5} className="text-white/90" />
              <span className="text-[11px] font-extrabold uppercase tracking-widest text-white" style={{ fontFamily: "var(--font-heading)" }}>
                {top}
              </span>
              <span className="text-[11px] text-white/75">{bottom}</span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
